import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { DatePicker } from "antd";
import { useEffect, useMemo, useState } from "react";
import { getWidthFromHeader, renderValueAsJSX } from "../../../../until";
import { Dashboard } from "../../../../components/ExportImgFigma";
import ".././stylestabs.scss";
import { ListField } from "../../../../api/Customer_V2/customerApi_V2";
import { ICustomerFields } from "../../../../api/salesSericeCustomer/salesSericeCustomerApi";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import FilterHeader from "./Components/FilterHeader";

const { RangePicker } = DatePicker;

const dataListFieldsByCustomerRecordActive = [
  {
    id: 99,
    title: "Lịch sử bảo trì bảo dưỡng",
    fields: [
      { id: 1, fieldCode: "unit", fieldLabel: "Đơn vị", inputType: "text", isActive: 1 },
      { id: 2, fieldCode: "pointOfSale", fieldLabel: "Điểm bán hàng", inputType: "text", isActive: 1 },
      { id: 3, fieldCode: "invoiceNumber", fieldLabel: "Số hóa đơn", inputType: "text", isActive: 1 },
      { id: 4, fieldCode: "repairOrderNumber", fieldLabel: "Số LSC", inputType: "text", isActive: 1 },
      { id: 5, fieldCode: "repairDate", fieldLabel: "Ngày sửa chữa", inputType: "text", isActive: 1 },
      { id: 6, fieldCode: "repairType", fieldLabel: "Loại hình sửa chữa", inputType: "text", isActive: 1 },
      { id: 7, fieldCode: "contactPerson", fieldLabel: "Người liên hệ", inputType: "text", isActive: 1 }
    ]
  }
];

const dataListFieldsByCustomerRecordNotActive = [
  { id: 99, title: "Lịch sử bảo trì bảo dưỡng", fields: [] }

];

const daumData = [
  {
    id: 1,
    code: "C53343401K1234",
    name: "Xe Đức - Du lịch",
    groupPermissionId: 100,
    fields: [
      { fieldId: 1, fieldCode: "unit", value: "Du lịch" },
      { fieldId: 2, fieldCode: "pointOfSale", value: "53343401K1234" },
      { fieldId: 3, fieldCode: "invoiceNumber", value: "Trắng" },
      { fieldId: 4, fieldCode: "repairOrderNumber", value: "408 20G AT" },
      { fieldId: 5, fieldCode: "repairDate", value: "21/02/2022" },
      { fieldId: 6, fieldCode: "repairType", value: "075/2025/HĐMB/KIAVL-KH" },
      { fieldId: 7, fieldCode: "contactPerson", value: "00001226" }
    ],
    permissionMenu: { groupPermissionId: 100, view: true, edit: false, delete: false }
  }
];

interface Prop {
  isSettingShow?: boolean;
  activeServiceRecordsTab: string
  setSettingShow?: (isClose: boolean) => void;
}


const MaintenanceHistory = ({ stData = {} as any }) => {

  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([]);
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([]);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });

  useEffect(() => {
    gListFieldsActive();
  }, []);

  useEffect(() => {
    const codes = dataFilterActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFilterActive]);


  const gListFieldsActive = async () => {
    const flattenedFields = dataListFieldsByCustomerRecordActive.flatMap((choice) =>
      choice.fields.map((field) => ({ ...field, parentId: choice.id }))
    );
    setDataFilterActive(flattenedFields);
    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive);
  };

  const generateColumnsFromCodesAgGridReact = (
    codes: ColumnKey[],
    fields: ICustomerFields[],
    actionColumn?: ColDef<any, any>,
    onToggleStatus?: (id: number, next: boolean, rowData: any) => void
  ): ColDef[] => {
    const baseColumns = codes
      ?.map((code) => {
        const field = fields.find((f) => f.fieldCode === code);
        if (!field) return null;

        return {
          headerName: field.fieldLabel,
          headerComponent: FilterHeader,
          field: field.fieldCode,
          colId: field.fieldCode,
          sortable: true,
          width: getWidthFromHeader(field.fieldLabel),
          cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode)
        } as ColDef;
      })
      .filter(Boolean) as ColDef[];

    return actionColumn ? [actionColumn, ...baseColumns] : baseColumns;
  };

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReact(
      columnsMapShow,
      dataFilterActive,
      undefined,
      (id: number, next: boolean, rowData: any) => console.log(id, next, rowData)
    );
  }, [columnsMapShow, dataFilterActive]);

  const tableData = useMemo(() => {
    return daumData.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.value;
        return acc;
      }, {});

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues
      };
    });
  }, []);


  const sumrepair = () => {
    let sum = 0
    const list = stData.xesohuu_show && stData.xesohuu_show.customer_care_repair_histories ? stData.xesohuu_show.customer_care_repair_histories : []
    list.map((val: any) => {
      sum += Number(val.repair_total_amount || 0)
    })
    return sum.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' });
  }

  return (
    <>
      <div className="custom-page-css w-full flex gap-3 mb-3">
        <div className="custom-page-css  flex flex-1 flex-column rounded border mw-50 ">
          <div className="custom-page-css w-full flex items-center gap-4 p-3 border-b">
            <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full w-1/3">
              <img
                src={Dashboard}
                alt=""
                style={{ height: 16, width: 16, objectFit: "contain" }}
              />
            </div>
            <span className="custom-page-css text-xl font-light text-475467">
              Tổng quan
            </span>
          </div>
          <div className="custom-page-css flex py-2">
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {stData.xesohuu_show && stData.xesohuu_show.customer_care_repair_histories ? stData.xesohuu_show.customer_care_repair_histories.length : 0}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Số lần BD
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {sumrepair()}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Tổng tiền
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                21/02/2022
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Ngày BD gần nhất
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="ag-theme-alpine custom-table-ag custom-page-css" style={{ width: "100%" }}>
        <AgGridReact
          rowData={stData.xesohuu_show && stData.xesohuu_show.customer_care_repair_histories ? stData.xesohuu_show.customer_care_repair_histories : []} // Row data for rows, we pass an empty array to show the "No Rows" overlay
          columnDefs={[
            { field: 'repair_book_date', headerName: 'Ngày KH hẹn vào xưởng' },
            { field: 'repair_branch_name', headerName: 'Đơn vị' },
            { field: 'repair_dept_code_list', headerName: 'Tổ' },
            { field: 'repair_description', headerName: 'Nội dung sửa chữa' },
            { field: 'repair_doc_date_remind', headerName: 'Ngày nhắc bảo dưỡng tiếp theo' },
            { field: 'repair_effective_get_date', headerName: 'Ngày sửa chữa' },
            { field: 'repair_employee_name', headerName: 'Cố vấn dịch vụ' },
            { field: 'repair_end_repair_date', headerName: 'Ngày hoàn thành' },
            { field: 'repair_estimated_finished_date', headerName: 'Ngày dự kiến hoàn thành' },
            { field: 'repair_item_amount', headerName: 'Doanh thu vật tư phụ tùng' },
            { field: 'repair_maintenance_type', headerName: 'Loại bảo dưỡng' },
            { field: 'repair_note', headerName: 'Mục cần làm sớm' },
            { field: 'repair_present_mile_age', headerName: 'Số km' },
            { field: 'repair_receive_date', headerName: 'Ngày giao xe' },
            { field: 'repair_repair_amount', headerName: 'Phí sửa chữa' },
            { field: 'repair_repair_type', headerName: 'Loại sửa chữa' },
            { field: 'repair_route_name', headerName: 'Chi nhánh' },
            { field: 'repair_technician_name', headerName: 'Kĩ thuật viên' },
            { field: 'repair_total_amount', headerName: 'Tổng doanh thu sửa chữa xe' },
          ]}
          rowHeight={55}
          domLayout="autoHeight"
          className="my-auto-height-grid w-100"
        />
      </div>
    </>
  );
};
export default MaintenanceHistory;
